import { Dialog, DialogProps } from '@economic/taco';
import React from 'react';
import { t } from '@lingui/macro';
import * as types from '../../../../../../types/internal-api';
import ProductCollectionForm from '../../../../../forms/Setup/ProductCollections/ProductCollectionForm';
import useQuery from '../../../../../shared/hooks/useQuery';
import Loader from '../../../../../shared/components/Loader';
import internalApiClient from '../../../../../shared/util/api/internalApiClient';
import { ArrowKeyNavigationProps } from '../../../../../shared/components/Form/BaseFormWithArrowKeyNavigation';
import { FormType, ShortcutsPopover } from '../../../../../shared/components/ui/ShortcutsPopover';

interface Props
    extends Partial<DialogProps>,
        Pick<ArrowKeyNavigationProps, 'idKeyProp' | 'collectionData' | 'currentItemId' | 'onArrowKeySaveAndChange'> {
    productCollectionId: number;
    onHide: () => void;
    refetch: () => void;
}

export function EditProductCollectionDialog(props: Props) {
    const { ...arrowKeyNavigationProps } = props;
    const productCollectionQuery = useQuery<types.ProductCollectionModel>(
        `/products/product-collections/${props.productCollectionId}`
    );

    async function create(values: types.ProductCollectionModel) {
        await internalApiClient.put(`products/product-collections/${props.productCollectionId}`, values);
        props.onHide();
        props.refetch();
    }

    if (productCollectionQuery.loading) {
        return <Loader />;
    }

    return (
        <>
            <div className="w-full flex justify-end mt-4">
                <ShortcutsPopover formType={FormType.Edit} />
            </div>
            <Dialog.Title>{t`Product collection`}</Dialog.Title>
            <ProductCollectionForm
                {...arrowKeyNavigationProps}
                initialValue={productCollectionQuery.data}
                onCreate={create}
                showSaveAndNewButton={false}
                disableId
            />
        </>
    );
}
